/* eslint-disable */


import Vue from "vue";
import App from "./App";
import router from "./router";
import "babel-polyfill";



import ToastPlugin from 'vux/src/plugins/toast/index.js'
import Confirm from 'vux/src/components/confirm/index.vue'

import qs from "qs";
import Cookies from "js-cookie";
import VueClipboard from "vue-clipboard2";
import "@/common/rem/rem.js";
import VueLazyload from "vue-lazyload";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import { urls, axios, common, filter } from "@/common/index";
import store from "@/common/store/";

import "./style/fa/css/font-awesome.min.css";
import "./style/iconfont2/iconfont.css";
import "./style/iconfont/iconfont.css";
import "swiper/dist/css/swiper.css";
import Vconsole from "vconsole";
import {
Toast,
Checkbox,
Field,
Button,
Icon,
Popup,
Picker,
Tabs,
Tab,
Popover,
Dialog,
NoticeBar,
Swipe,
SwipeItem,
Image,
Loading,
Switch,
} from "vant";
import ElementUI from "@/common/utils/element.js";
import "element-ui/lib/theme-chalk/index.css";
import i18n from "./i18n/i18n";
import "vant/lib/index.css";

let telegram_credential = null;
if (window.TelegramWebviewProxy) {
telegram_credential =
(window.Telegram &&
window.Telegram.WebApp &&
window.Telegram.WebApp.initDataUnsafe &&
window.Telegram.WebApp.initDataUnsafe.start_param) ||
localStorage.getItem("telegram_credential");
if (telegram_credential) {
localStorage.setItem("telegram_credential", telegram_credential);
window.telegram_credential = telegram_credential;
}
}

NProgress.configure({
easing: "ease", // 动画方式
speed: 500, // 递增进度条的速度
showSpinner: false, // 是否显示加载ico
trickleSpeed: 200, // 自动递增间隔
minimum: 0.3, // 初始化时的最小百分比
});

Vue.use(VueLazyload);
Vue.use(VueClipboard);
Vue.use(ElementUI);
Vue.use(Toast);
Vue.use(Checkbox);
Vue.use(Field);
Vue.use(Button);
Vue.use(Icon);
Vue.use(Popup);
Vue.use(Picker);
Vue.use(Tabs);
Vue.use(Tab);
Vue.use(Popover);
Vue.use(Dialog);
Vue.use(NoticeBar);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Image);
Vue.use(Loading);
Vue.use(Switch);
Vue.use(ToastPlugin, { position: "middle", width: "8rem", time: 2500 });
Vue.component("confirm", Confirm);









Vue.config.productionTip = false;

Vue.prototype.$api = axios;
Vue.prototype.$urls = urls;
Vue.prototype.$common = common;
Vue.prototype.$filter = filter;
Vue.prototype.$qs = qs;
Vue.prototype.$Cookies = Cookies;

Vue.prototype.$project = "88phat";


import { toFixed, switchCase } from "@/common/filter/index.js";
import { parseTime } from "@/common/utils/Date.js";
Vue.filter("ToFixed", toFixed);
Vue.filter("parseTime", parseTime);
Vue.filter("switchCase", switchCase);

import ComHeader from "./components/com-header.vue";
Vue.component("com-header", ComHeader);

import refreshAcount from "@/common/components/refreshAcount/index.vue";
Vue.component("refreshAcount", refreshAcount);


import GL_Component from "./utils/globalComponent.js";
Vue.use(GL_Component);


import GL_ui from "./utils/global-ui.js";
Vue.use(GL_ui);

import limitNum from "@/common/directive/onlyNum";
Vue.directive("limitNum", limitNum);

if (localStorage.getItem("showVConsole")) {
var vconsole = new Vconsole();
}

store.dispatch("initLoginEffect");

/* eslint-disable no-new */
new Vue({
el: "#app",
router,
store,
i18n,
components: { App },
template: "<App/>",
});



// WEBPACK FOOTER //
// ./src/pages/build800/build800.js